<template>
  <div class="banner-manager">
    <div class="top">
      <el-button type="success" @click="createBanner">新增Banner</el-button>
    </div>
    <div class="tips" style="margin: 15px 0">
      圖片壓縮網址:
      <a href="https://tinyjpg.com/" target="_blank">https://tinyjpg.com/</a>
    </div>
    <el-table
      :data="bannerData.list"
      border
      stripe
      empty-text="沒有資料"
      style="width: 100%"
    >
      <el-table-column prop="image" label="預覽圖" width="400">
        <template slot-scope="{ row }">
          <div class="center">
            <img class="image" :src="row.image" alt />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="連結" width="500"></el-table-column>
      <el-table-column label="修改" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="warning" @click="editBanner(row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="刪除" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="danger" @click="remove(row.id)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="size"
      :total="bannerData.total"
      :current-page.sync="currentPage"
      @current-change="pageChange"
    ></el-pagination>
    <BannerEditor
      :bannerEditorVisible.sync="bannerEditorVisible"
      :bannerForm="bannerForm"
      :isCreate="isCreate"
      @saveBanner="saveBanner"
    ></BannerEditor>
  </div>
</template>

<script>
import Api from "@/api/MaganmentApi";
import _ from "lodash";
import Swal from "sweetalert2";
import BannerEditor from "@/components/management/BannerEditor";

export default {
  data() {
    return {
      bannerEditorVisible: false,
      size: 10,
      currentPage: 1,
      bannerData: {
        list: [],
        total: 0
      },
      isCreate: false,
      bannerForm: {
        url: "",
        image: ""
      }
    };
  },
  computed: {},
  methods: {
    init() {
      this.currentPage = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.getBanner();
    },
    async getBanner() {
      const query = {
        page: this.currentPage,
        size: this.size,
        manager: true
      };
      const res = await Api.getBanner(query);
      this.bannerData = res.data;
    },
    replaceQuery() {
      let newQuery = {
        page: this.currentPage
      };
      this.$router.replace({ query: newQuery });
    },
    pageChange() {
      this.replaceQuery();
      this.getBanner();
    },
    changeType() {
      this.replaceQuery();
      this.getBanner();
    },
    createBanner() {
      this.isCreate = true;
      this.bannerForm = {
        url: "",
        image: ""
      };
      this.bannerEditorVisible = true;
    },
    editBanner(data) {
      this.isCreate = false;
      this.bannerForm = _.cloneDeep(data);
      this.bannerEditorVisible = true;
    },
    async saveBanner(bannerForm) {
      try {
        if (this.isCreate) {
          await Api.createBanner(bannerForm);
          this.init();
          this.bannerEditorVisible = false;
          this.$message({
            message: "新增成功",
            type: "success"
          });
        } else {
          await Api.updateBanner(bannerForm);
          this.init();
          this.bannerEditorVisible = false;
          this.$message({
            message: "修改成功",
            type: "success"
          });
        }
      } catch (e) {
        Swal.fire({
          title: "Error!",
          text: "發生錯誤，請檢查網路或聯絡管理人員",
          icon: "error"
        });
      }
    },
    async remove(id) {
      Swal.fire({
        title: "確定刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "確定"
      }).then(async result => {
        if (result.value) {
          try {
            await Api.removeBanner(id);
            _.remove(this.bannerData.list, banner => {
              return banner.id == id;
            });
            this.$set(this.bannerData.list, this.bannerData.list);
            this.$message({
              message: "刪除成功",
              type: "success"
            });
          } catch (e) {
            Swal.fire({
              title: "Error!",
              text: "發生錯誤，請檢查網路或聯絡管理人員",
              icon: "error"
            });
          }
        }
      });
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  components: {
    BannerEditor
  }
};
</script>

<style lang="scss" scoped>
.banner-manager {
  .top {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .el-radio-group {
      margin-right: 50px;
    }
  }
}
.image {
  width: 170px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
